var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxchangeAlertsRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.858398 0H5.50448L19.1421 18.5L5.50448 40H0.858398L14.037 18.5L0.858398 0Z",
    fill: "#317397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxchangeAlertsRightArrow);
export default __webpack_public_path__ + "static/media/rxchange_alerts_right_arrow.e336f238e40f64194151b63b6d0c8771.svg";
export { ForwardRef as ReactComponent };